import { useNavigate } from "react-router-dom";
import { MOBILE } from "../../constants/breakpoints";
import { BodyRegular, HealLine3 } from "../../shared/typography";
import { Col } from "../Assets/style";
import notFoundImage from "./../../assets/notFoundImages/404.png";
import { css } from "@emotion/react";
import { BtnComp, ImgComp } from "./style";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <>
            <Nav />
            <Col padding="100px 0 0 0" align="center">
                <ImgComp
                    src={notFoundImage}
                    alt='no-asset-found'
                />
                <HealLine3>Oops! Something went wrong</HealLine3>
                <BodyRegular>Have you tried turning it off and on again?</BodyRegular>
                <BtnComp
                    onClick={() => {
                        navigate('/');
                    }}
                >
                    Go Home
                </BtnComp>
            </Col>
            <Footer />
        </>
    )
}

export default NotFoundPage;